import React from 'react';
import PropTypes from 'prop-types';
import {
    collapse,
    expand,
    setContentToState
} from '../../accordion/js/accordion.component';
import ListingSelect from '../../listing/js/ListingSelect';
import ListingCheckList from '../../listing/js/ListingCheckList';
import { CONTROL_TYPE_SELECT, CONTROL_TYPE_CHECKLIST } from '../../listing/js/constants';

export default class QualifiedPlayersListingFilters extends React.PureComponent {
    constructor(props) {
        super(props);

        this.filtersRef = this.filtersRef.bind(this);
    }

    componentDidMount() {
        setContentToState(this.filtersElement, this.props.isFiltersVisible);
    }

    filtersRef(el) {
        this.filtersElement = el;
    }

    componentDidUpdate(prevProps) {
        if (prevProps.isFiltersVisible !== this.props.isFiltersVisible) {
            this.handleFiltersVisibility();
        }
    }

    handleFiltersVisibility() {
        if (this.filtersElement) {
            if (this.props.isFiltersVisible) {
                expand(this.filtersElement);
            } else {
                collapse(this.filtersElement);
            }
        }
    }

    renderFilter(filterConfig) {
        switch (filterConfig.type) {
            case CONTROL_TYPE_CHECKLIST:
                return (
                    <ListingCheckList key={filterConfig.name}
                        config={filterConfig}
                        value={this.props.filters[filterConfig.name]}
                        onChange={this.props.onFiltersChange}/>
                );

            case CONTROL_TYPE_SELECT:
                return (
                    <ListingSelect
                        key={filterConfig.name}
                        config={filterConfig}
                        value={this.props.filters[filterConfig.name]}
                        onChange={this.props.onFiltersChange}/>
                );
            default:
                throw new Error('unknown control type');
        }
    }

    render() {
        return (
            <div ref={this.filtersRef}
                className="qualified-players-listing__filters">
                <div className="container qualified-players-listing__filters-content">
                    {this.props.options.filters.map((filterConfig) => this.renderFilter(filterConfig))}
                </div>
            </div>
        );
    }
}

QualifiedPlayersListingFilters.defaultProps = {
    options: {
        // filters config
        filters: [],
    }
};

QualifiedPlayersListingFilters.propTypes = {
    onFiltersChange: PropTypes.func.isRequired,
    filters: PropTypes.object.isRequired,
    isFiltersVisible: PropTypes.bool.isRequired,
    options: PropTypes.object,
};
